import React from "react";
import {
  EMGRowType,
  FWaveRowType,
  HReflexRowType,
  MotorRowType,
  SensoryRowType,
} from "../types/NCS_EMG";
import {
  autoFillFwave,
  autoFillHreflex,
  autoFillMotor,
  autoFillSensory,
} from "../api/ruleEngine";

interface AutoFillNotesProps {
  motorRows: MotorRowType[];
  sensoryRows: SensoryRowType[];
  fwaveRows: FWaveRowType[];
  hreflexRows: HReflexRowType[];
  emgRows: EMGRowType[];
  age?: number | string;
  onUpdateNotes: (notes: {
    motor: string[];
    sensory: string[];
    fwave: string[];
    hreflex: string[];
    emg: string[];
  }) => void;
}

const AutoFillNotes: React.FC<AutoFillNotesProps> = ({
  motorRows,
  sensoryRows,
  fwaveRows,
  hreflexRows,
  emgRows,
  age,
  onUpdateNotes,
}) => {
  const handleClick = async () => {
    const numericAge = age !== undefined && age !== "" ? Number(age) : undefined;

    try {
      const [motorNotes, sensoryNotes, fwaveNotes, hreflexNotes] = await Promise.all([
        autoFillMotor(motorRows, numericAge),
        autoFillSensory(sensoryRows, numericAge),
        autoFillFwave(fwaveRows, numericAge),
        autoFillHreflex(hreflexRows, numericAge),
      ]);

      const emgNotes = emgRows.map(() => "");

      onUpdateNotes({
        motor: motorNotes,
        sensory: sensoryNotes,
        fwave: fwaveNotes,
        hreflex: hreflexNotes,
        emg: emgNotes,
      });
    } catch (error) {
      console.error("Auto-fill failed:", error);
      alert("An error occurred during auto-fill.");
    }
  };

  return (
    <button onClick={handleClick} className="app-button success">
      Auto-fill Notes
    </button>
  );
};

export default AutoFillNotes;
